"use client";
import { Button } from "@/components-shared/ui/button";
import config from "@/lib/config";
import ehjzleeInstance from "@/lib/ehjzleeInstance";
import { cn } from "@/lib/utils";
import { toggleDrawer } from "@/redux/slices/drawer.slice";
import { RootState } from "@/redux/store";
import { Heart } from "lucide-react";
import React, { MouseEvent } from "react";
import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
} from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "./CircularProgress";

const FavoriteBtn = ({
  id,
  isFavorite,
  isLoading,
  refetch,
}: {
  id: string;
  isFavorite: { value: boolean; toggle: () => void };
  isLoading: { value: boolean; setTrue: () => void; setFalse: () => void };
  refetch?: (
    options?: (RefetchOptions & RefetchQueryFilters<any>) | undefined
  ) => Promise<QueryObserverResult<any, unknown>>;
}) => {
  const { isLoggedIn } = useSelector((state: RootState) => state.login);
  const dispatch = useDispatch();
  const handleFavorite = async (e: MouseEvent) => {
    e.stopPropagation();
    if (!isLoggedIn) dispatch(toggleDrawer({ isOpen: true }));
    else {
      try {
        isLoading.setTrue();
        await ehjzleeInstance.put(`${config.props}/${id}/${config.fav}`);
        if (refetch) refetch();
        isFavorite.toggle();
        isLoading.setFalse();
      } catch (err) {
        isLoading.setFalse();
      }
    }
  };
  return (
    <Button
      disabled={isLoading.value}
      className={cn(
        "disabled:cursor-progress p-0 bg-black/50 rounded-full size-7"
      )}
      onClick={(e) => handleFavorite(e)}
      size={"icon"}
      aria-label="favorite button"
      type="button"
    >
      {isLoading.value ? (
        <CircularProgress size="sm" />
      ) : (
        <Heart
          className={cn("size-5", {
            "fill-green-main": isFavorite.value,
          })}
        />
      )}
    </Button>
  );
};

export default FavoriteBtn;
